import { useEffect } from 'react';

export default function useAutoFocus(pageKey: string | undefined, selector = '#video-details button') {
  useEffect(() => {
    (document.querySelector(selector) as HTMLElement)?.focus({ preventScroll: true });
  }, [pageKey, selector]);
}
